/** Fixed invoice validation copy shared by the action, dialog and toast. */
export type InvoiceCreateField = 'status' | 'gst' | 'amount' | 'billingLines' | 'client';

const INVOICE_CREATE_ERRORS = {
  invoice_source_lines_required: {
    field: 'status',
    error:
      'A Sent or Paid invoice needs at least one billing line linked to a delivered service, claim or contribution. Save as Draft instead.',
  },
  invoice_gst_not_applicable: {
    field: 'gst',
    error: "GST can't be charged on this invoice.",
  },
  invoice_total_amount_mismatch: {
    field: 'amount',
    error: 'Total must equal amount plus GST.',
  },
  invoice_mixed_funding_requires_line_items: {
    field: 'billingLines',
    error: 'Add at least one billing line for Mixed Funding.',
  },
  invoice_client_not_found: {
    field: 'client',
    error: 'The selected client could not be found.',
  },
} as const;

/**
 * Match known tokens only; never humanise arbitrary database text. The
 * database raises some of these with details after a colon (for example
 * `invoice_gst_not_applicable:funding_program=PRIVATE,tax_amount=15`), so the
 * token is everything before the first colon. The details are never shown.
 */
export function invoiceCreateFailure(value: unknown) {
  const record =
    typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : null;
  const candidates = record ? [record.code, record.message, record.error] : [value];
  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue;
    const text = candidate.trim();
    const colon = text.indexOf(':');
    const code = colon === -1 ? text : text.slice(0, colon);
    if (Object.hasOwn(INVOICE_CREATE_ERRORS, code)) {
      const knownCode = code as keyof typeof INVOICE_CREATE_ERRORS;
      return { code: knownCode, ...INVOICE_CREATE_ERRORS[knownCode] };
    }
  }
  return null;
}
